import { useState } from "react"
import { upperFirst } from "lodash"
import { Button } from "@mui/material"
import PropTypes from "prop-types"
import Error from "../../components/login/form-error"
import "./style.scss"

export default function LinkAccount({ error, provider }) {
  const [errorMessage, setErrorMessage] = useState(error)

  const clearError = () => {
    setErrorMessage()
  }

  const goTo = (url) => {
    window.location = url
  }

  return (<div className="LinkAccount">
    <div className="title">Link your account</div>
    <div className="text">
      Your domain requires you link your account to {upperFirst(provider)}.
    </div>
    {errorMessage && <Error errorMessage={errorMessage} clearError={clearError} />}
    <Button variant="contained" color="primary" onClick={() => goTo(`/auth/${provider}/link`)} className="link">
      Link account to {provider}
    </Button>
    <Button variant="contained" color="primary" className="logout" onClick={() => goTo("/logout")}>
      Logout
    </Button>
  </div>
  )
}

LinkAccount.propTypes = {
  provider: PropTypes.string.isRequired,
  error: PropTypes.string,
}
